import { ImageRenderer } from '../../components/renderers/image.renderer';
import { TrainersServices } from '../../services/trainers.service';
import ListComponent from '../common/ListComponent';

export function TrainersList() {
    return (
        <ListComponent
            title='Trainers'
            getAll={TrainersServices.getAll}
            deleteById={TrainersServices.deleteById}
            columns={
                [
                    { field: 'profile_image', headerName: 'Image', flex: 0.2, renderCell: ImageRenderer },
                    //TODO Show the head coaches? allow to filter or something similar?
                    // { field: 'role_id', headerName: 'Head Coach', flex: 0.3, valueGetter: (value: any) => value == 4 ? 'X' : '' },
                    { field: 'name', headerName: 'Name', flex: 1 },
                    {
                        field: 'user_studios',
                        headerName: 'Studios',
                        flex: 1,
                        valueGetter: (studios: any) => studios.map((value: any) => value.studio.name).join(', '),
                    }
                ]

            }

        />
    );
};